/*
 * Copyright (C) 2024 S&P Global.
 * All Rights Reserved
 */
import { AppIdentifier } from "@finos/fdc3";
import { AppType } from "../types";
import { FusionInteropMessage, FusionInteropMessageHeader, SystemMessagePayload } from "../types/message";

export class MessageHeaderService {
  private _browserGlobalScope: Window & typeof globalThis;

  constructor(browserGlobalScope: Window & typeof globalThis) {
    // console.log("MessageHeaderService.constructor");
    this._browserGlobalScope = browserGlobalScope;
  }

  // prettier-ignore
  public createHeader(originatingAppType: AppType,
                      targetAppType: AppType,
                      originatingAppIdentifier?: AppIdentifier,
                      targetAppIdentifier?: AppIdentifier,
                      correspondingRequestMessage?: FusionInteropMessage<SystemMessagePayload>): FusionInteropMessageHeader {
    return {
      correlationId: correspondingRequestMessage?.header?.correlationId ?? this._browserGlobalScope.crypto?.randomUUID(),
      createdTimestamp: Date.now(),
      sentTimestamp: undefined,
      receivedTimestamp: undefined,
      originatingAppType,
      targetAppType,
      originatingAppIdentifier,
      targetAppIdentifier,
      correspondingRequestMessage,
    } as FusionInteropMessageHeader;
  }
}
